import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalEditorFlipHorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-editor-flip-horizontal"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M10 2.5V5m0 3.75v2.5M10 15v2.5M2.74 6.659l3.656 2.813c.234.18.351.27.393.379a.42.42 0 0 1 0 .298c-.042.11-.159.2-.393.38L2.74 13.34c-.345.265-.517.398-.662.396a.42.42 0 0 1-.322-.158c-.09-.114-.09-.331-.09-.766V7.187c0-.435 0-.652.09-.766a.42.42 0 0 1 .322-.158c.145-.002.317.13.662.396m14.52 0-3.656 2.813c-.234.18-.351.27-.393.379a.42.42 0 0 0 0 .298c.042.11.159.2.393.38l3.656 2.812c.345.265.517.398.662.396a.42.42 0 0 0 .322-.158c.09-.114.09-.331.09-.766V7.187c0-.435 0-.652-.09-.766a.42.42 0 0 0-.322-.158c-.145-.002-.317.13-.662.396"
        />
    </svg>
);
const Memo = memo(ImageModalEditorFlipHorizontalIcon);
export default Memo;
